import { useState, useEffect } from "react";
import "../src/assets/components/global.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo from "../src/assets/components/images/Lanao_del_Norte_Seal.png";

function Header() {
  const [currentDate, setCurrentDate] = useState();
  const [currentTime, setCurrentTime] = useState("");

  useEffect(() => {
    // Function to update date and time
    const updateDateTime = () => {
      const now = new Date();
      const dateOptions = { year: "numeric", month: "long", day: "numeric" };
      const timeOptions = {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true,
      };

      setCurrentDate(now.toLocaleDateString(undefined, dateOptions));
      setCurrentTime(now.toLocaleTimeString(undefined, timeOptions));
    };

    // Update date and time immediately
    updateDateTime();

    // Update date and time every second
    const intervalId = setInterval(updateDateTime, 1000);

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, []); // Empty dependency array means this effect runs once after the initial render

  return (
    <div id="header">
      <div className="header-container wrap">
        <div className="header-logo">
          <img src={logo} alt="" title="" width="100px" height="100px" />
          <h3>Barangay Gumagamot Lala L.D.N</h3>
        </div>
        <nav className="header-nav">
          <ul>
            <li>
              Date:<label>{currentDate}</label>
            </li>
            <li>
              Time:<label>{currentTime}</label>
            </li>
          </ul>
          <ul>
            <li>
              <a href="Community-Features">Community Features</a>
            </li>
            <li>
              <a href="System-Info">System Information</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}

export default Header;
